module.exports = __webpack_public_path__ + "static/media/wait_turn.1828b828.svg";